import { Handle, Position } from "@xyflow/react";
interface PayableNodeData {
  id: string;
  name: string;
  bankId: string;
  partnerName?: string;
  totalAmount?: number;
  paidAmount?: number;
}

interface PayableNodeProps {
  data: PayableNodeData;
  isConnectable: boolean;
}

function PayableNode({ data, isConnectable }: PayableNodeProps) {
  return (
    <div
      className="p-3 rounded-lg bg-white shadow-md border-2 border-amber-400"
      style={{ minWidth: "180px" }}
    >
      <Handle
        type="target"
        position={Position.Left}
        id="left"
        style={{ background: "#ef4444" }}
        isConnectable={isConnectable}
      />

      <div className="text-center">
        <div className="font-bold text-sm">{data.name}</div>
        {data.partnerName && (
          <div className="text-xs text-gray-500 mt-1">合作方：{data.partnerName}</div>
        )}
        <div className="text-xs text-amber-600 mt-1">
          應付金額: ${Math.round(data.totalAmount || 0).toLocaleString()}
        </div>
      </div>
    </div>
  );
}

export default PayableNode;
